export const deepMerge = (...objs) => {
  const result = {};

  const merge = (obj) => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (Object.prototype.toString.call(obj[key]) === "[object Object]") {
          result[key] = deepMerge(result[key] ?? {}, obj[key]);
        } else {
          result[key] = obj[key];
        }
      }
    }
  };

  objs.forEach((obj) => {
    merge(obj);
  });

  return result;
};

export const parseOrderByCharacter = (mappingCourier, order) => {
  const { tracking_detail, tracking_company } = order;
  const newTrackingCompany =
    mappingCourier.couriers.find((item) => item.from === tracking_company)
      ?.to === undefined
      ? tracking_company
      : mappingCourier.couriers.find((item) => item.from === tracking_company)
          ?.to;
  return { newTrackingDetail: tracking_detail, newTrackingCompany };
};

function replaceBlackListLocation(data, blacklist, replaceMsg) {
  data = typeof data === "string" ? JSON.parse(data) : data;
  let res = data.map((item) => {
    const { message } = item;
    const { listLocation } = blacklist;
    const result = message.split(" ").map((item) => {
      return typeof listLocation.find((e) => {
        let regexItem = item.replace(/[^\w\s]/gi, "").trim();
        let elementCheck = e.replace(/[^\w\s]/gi, "").trim();
        return (
          elementCheck.toLowerCase() === regexItem.toLowerCase() ||
          regexItem.toLowerCase().includes(elementCheck.toLowerCase())
        );
      }) === "string"
        ? replaceMsg
        : item;
    });
    return !blacklist.isBlockEntry
      ? { ...item, message: result.join(" ").trim() }
      : {
          ...item,
          message: result.some((item) => item === replaceMsg)
            ? replaceMsg
            : result.join(" ").trim(),
        };
  });
  console.log(res);
  return res;
}

export const setLocalStorage = (key, value, minutes) => {
  if (!key || !value) return console.log("key or value not valid");
  const hasStorage = "localStorage" in window && window.localStorage;
  if (!hasStorage) return console.log("not prepare yet");
  const item = { value };
  if (minutes) item.expiry = Date.now() + 60000 * minutes;
  return localStorage.setItem(key, JSON.stringify(item));
};

export const getLocalStorage = (key) => {
  let item = localStorage.getItem(key);
  if (!item) return null;
  const parseItem = JSON.parse(item);
  if (parseItem.expiry && Date.now() > parseItem.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return parseItem.value;
};
